<template>
  <span class="back" @click="backFunc"><arrow-left-bold class="icon" /></span>
</template>

<script>
import { ArrowLeftBold } from "@element-plus/icons";
import { useRouter } from "vue-router";

export default {
  name: "BackPage",
  components: { ArrowLeftBold },
  emits: ["clickFunc"],
  setup(props, context) {
    const router = useRouter();
    const backFunc = () => {
      router.back();
      context.emit("clickFunc");
    };
    return {
      backFunc,
    };
  },
};
</script>

<style scoped lang="scss">
@import "../style/func.scss";
.back {
  margin-right: rem(30px);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  font-size: rem(16px);
  cursor: pointer;
}
.icon {
  width: rem(16px);
  margin: rem(6px);
}

@media screen and (max-width: 600px) {
  .back {
    margin-right: rem(6px);
  }
  .icon {
  width: rem(12px);
  margin: rem(4px);
}
}
</style>
